import * as React from "react";
import ReporteesTable from "./ReporteesTable";



export default function AllReporteesTableList({searchTerm,employeeData,shiftStart,shiftEnd}) {
  return <ReporteesTable searchTerm={searchTerm} employeeData={employeeData} shiftStart = {shiftStart}
  shiftEnd ={shiftEnd}/>;
}
